export function checkSponsoredWidgetStateApplicability(state, device) {
    if (state.startDateTime && device.dateTime < state.startDateTime) {
        return 'device `dateTime` < `startDateTime`';
    }
    return null;
}
